import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=b6e078ee&scoped=true&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=b6e078ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e078ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6e078ee')) {
      api.createRecord('b6e078ee', component.options)
    } else {
      api.reload('b6e078ee', component.options)
    }
    module.hot.accept("./ProductCard.vue?vue&type=template&id=b6e078ee&scoped=true&", function () {
      api.rerender('b6e078ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Cards/ProductCard.vue"
export default component.exports